import { useState, useEffect, createContext, useReducer } from "react"

export const ProductsContext = createContext()

export function productsReducer(state, action) {
    switch(action.type) {
        case "GET_PRODUCTS" :
            return { products: action.payload }
        case "ADD_PRODUCT" :
            return {
                products: [ ...state.products, action.payload ],
                notification: { type: action.type }
            }
        case "UPDATE_PRODUCT" :
            return {
                products: action.payload,
                notification: { type: action.type }
            }
        case "DELETE_PRODUCT" :
            return {
                products: state.products.filter(a => a._id !== action.payload),
                notification: { type: action.type }
            }
        case "PRODUCT_ERROR_ACTION_FORBIDDEN" :
            return {
                products: state.products,
                notification: { type: action.type }
            }
        default :
            return state
    }
}

export function ProductsContextProvider({ children }) {
    const [state, dispatch] = useReducer(productsReducer, { products: null })

    useEffect(() => {
        async function fetchProducts() {
            //const response = await fetch("https://exclusive-hqu3.vercel.app/api/getProducts")
            //https://exclusive-hqu3.vercel.app
            //${process.env.REACT_APP_API_BASE_URL}
            //const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/getProducts`)
            const response = await fetch(`http://localhost:3001/api/getProducts`)
            const json = await response.json()

            if (response.ok) {
                dispatch({ type: "GET_PRODUCTS", payload: json })
            }
        }

        fetchProducts()
    }, [])

    return (
        <ProductsContext.Provider value={{ ...state, dispatch }}>
            {children}
        </ProductsContext.Provider>
    )
} 